import NodeCache from 'node-cache'

const cache = new NodeCache({ stdTTL: 300 })

export const getCache = (): object => cache

export const setData = (key, data): boolean => cache.set(key, data)

export const getData = (key): undefined | object => cache.get(key)
